import * as React from 'react';
import { connect } from 'react-redux';
import { Accordion, Card, Image } from 'react-bootstrap';
import './PolicyDetails.css';
import { useSelector, useDispatch } from 'react-redux'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { DASHBOARD, PERSONAL_INSURANCE, FNOL_SUBMIT_CLAIM } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showComingSoon, showCallMeModal } from '../../../actions/modalActions';
import { navigateTo } from '../../../actions/navigationActions';
import { syncCoverWithProfile, toggleSelfInspectPhotos } from '../../../actions/selfInspectActions';
import { setCoverFromPersonalInsurance, clearSelectedDamages, resetFNOL, setStep } from '../../../actions/claimSubmitActions';
import SelfinspectDetails from '../../SelfInspection/SelfinspectDetails/SelfinspectDetails';
import OptionalExtraTile from '../OptionalExtraTile';
import { COMPREHENSIVE_MOTORBIKE_COVER_TYPE, THEFT_MOTORBIKE_COVER_TYPE, THIRDPARTY_MOTORBIKE_COVER_TYPE, THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE } from '../../../constants/constants';
import FAQItem from '../../FAQ/FAQItem';

const PolicyDetailsMotorbike = () => {
    const profileState = useSelector(state => state.profile);
    const salesState = useSelector(state => state.sales);
    let showPhotos = useSelector(state => state.selfInspect.showSelfInspectPhotos);
    let hasError = useSelector(state => state.selfInspect.hasError);

    const [reminderDismissed, updateReminderDismissed] = useState(false);
    const [isInEdit, updateEditing] = useState(false);
    const dispatch = useDispatch();

    const [accordionFAQActiveKey, setAccordionFAQActiveKey] = useState(-1);

    function handleShowSelfInspectPhotos() {
        dispatch(toggleSelfInspectPhotos(!showPhotos));
    }

    function editPolicyInfo() {
        dispatch(showComingSoon());
    }

    function cancelEdit() {
        updateEditing(false);
    }

    function saveEdit() {
        updateEditing(false);
    }

    function dismissMonthlyMileageReminder() {
        updateReminderDismissed(true);
    }

    function handleSelfInspectionRequired() {
        dispatch(syncCoverWithProfile())
    }

    async function submitAClaim() {
        await dispatch(resetFNOL());
        await dispatch(clearSelectedDamages());
        await dispatch(setCoverFromPersonalInsurance(cover));
        await dispatch(setStep(1, 1));
        await dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    function handleCallMeBack() {
        dispatch(showCallMeModal(true));
    }

    function getDropdownItems(items: any) {
        let faqSet = [{
            header: "Motorbike details",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Make</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.vehicleMake + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Model</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.vehicleModel + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Series</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.vehicleSeries + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Year</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.year + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Registration number</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.registrationNumber + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Colour</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.colour + '</p>' +
                '</div>',
            id: 1
        },
        {
            header: "Registered owner",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Name</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.firstName + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Surname</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.surname + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">ID no.</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.idNumber + '</p>' +
                '</div>',
            id: 2
        },
        {
            header: "Use and location",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Type of use</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.vehicleUse + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Average monthly distance travelled</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.approximateKilometers + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Parked at night</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].address.fullAddress + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Parked during day</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].address.dayAddress + '</p>' +
                '</div>',
            id: 3
        },
        {
            header: "Named rider",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Name</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.firstName + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Surname</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.surname + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">ID no.</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.idNumber + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Date of birth</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.dateOfBirth + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Licence type</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.licenseCode + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Licence year</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.licenseIssueDate + '</p>' +
                '</div>',
            id: 4
        },
        {
            header: "Insurance history",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Full comprehensive insurance</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].insuranceDuration + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Last stolen claim</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].lastStolenClaim + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Last accident claim</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].lastStolenClaim + '</p>' +
                '</div>',
            id: 5
        },
        ];

        let faq;
        if (faqSet) {
            faq = faqSet.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={accordionFAQActiveKey} />
                }
            });
        }

        return faq;
    }

    const cover = useSelector(state => state.profile.selectedPersonalCover)
    let faq = getDropdownItems(cover);
    const selfInspectionEnabled = useSelector(state => state.ssp.selfInspectionEnabled);
    const isMobile = window.innerWidth <= 975;
    let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }]

    let selfInspectionRequired = <>Self-inspection required.
        <Link id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder" to="#" onClick={handleSelfInspectionRequired} >Click here.</Link></>
    if (window.innerWidth < 359) {
        selfInspectionRequired = <> Self-inspection required.<br />
            <Link id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder" to="#" onClick={handleSelfInspectionRequired} >Click here.</Link></>
    }

    let vapsList = "";
    if (cover.vaps) {
        if (cover.vaps.length > 0) {
            vapsList = cover.vaps.map((item) => {
                if (item.id.toUpperCase() === "E7208990-B96F-4987-BBDD-A73ECA2D901C") { /*credit shortfall*/
                    return <OptionalExtraTile id={item.id}
                        hasVAP={item.isActive}
                        productName={item.title}
                        imageClass={item.icon}
                        addItem={editPolicyInfo}
                        removeItem={editPolicyInfo}
                        canUse={false}
                        cost={profileState.currencySymbol + " " + item.premiumText + " pm"}
                        isAccessory={false} />
                }
                else if (item.id.toUpperCase() === "916E328E-AD96-4D6C-A3E8-42B095BCB805") {/*tyre and rim*/
                    return <OptionalExtraTile id={item.id}
                        hasVAP={item.isActive}
                        productName={item.title}
                        imageClass={item.icon}
                        addItem={editPolicyInfo}
                        removeItem={editPolicyInfo}
                        canUse={false}
                        cost={profileState.currencySymbol + " " + item.premiumText + " pm"}
                        isAccessory={false} />
                }
                else if (item.id.toUpperCase() === "0EC1DCAA-A6F7-4C86-905A-00FD55022569") {/*scratch and dent*/
                    return <OptionalExtraTile id={item.id}
                        hasVAP={item.isActive}
                        productName={item.title}
                        imageClass={item.icon}
                        addItem={editPolicyInfo}
                        removeItem={editPolicyInfo}
                        canUse={false}
                        cost={profileState.currencySymbol + " " + item.premiumText + " pm"}
                        isAccessory={false} />
                }
                else if (item.id.toUpperCase() === "5EEDC56C-F17A-4AB8-97CC-58E02D612865") {/*Little dings*/
                    return <OptionalExtraTile id={item.id}
                        hasVAP={item.isActive}
                        productName={item.title}
                        imageClass={item.icon}
                        addItem={editPolicyInfo}
                        removeItem={editPolicyInfo}
                        canUse={false}
                        cost={profileState.currencySymbol + " " + item.premiumText + " pm"}
                        isAccessory={false} />
                }
                else if (item.id.toUpperCase() === "4C0CB071-42DD-4060-99FF-9F0214113461") {/*tyre and rim + scratch and dent*/
                    return <OptionalExtraTile id={item.id}
                        hasVAP={item.isActive}
                        productName={item.title}
                        imageClass={item.icon}
                        addItem={editPolicyInfo}
                        removeItem={editPolicyInfo}
                        canUse={false}
                        cost={profileState.currencySymbol + " " + item.premiumText + " pm"}
                        isAccessory={false} />
                }
                else {
                    return <OptionalExtraTile id={item.id}
                        hasVAP={item.isActive}
                        productName={item.title}
                        imageClass={item.icon}
                        addItem={editPolicyInfo}
                        removeItem={editPolicyInfo}
                        canUse={false}
                        cost={profileState.currencySymbol + " " + item.premiumText + " pm"}
                        isAccessory={false} />
                }
            })
        }
    }

    let accessoryList = "";
    if (cover.accessories) {
        if (cover.accessories.length > 0) {
            accessoryList = cover.accessories.map((item) => {
                return <OptionalExtraTile id={item.id}
                    hasVAP={item.isActive}
                    productName={item.title}
                    imageClass={item.icon}
                    addItem={editPolicyInfo}
                    removeItem={editPolicyInfo}
                    canUse={false}
                    cost={profileState.currencySymbol + " " + item.subtitle}
                    isAccessory={true} />
            })
        }
    }

    let coverStartDate = (cover.riskItems[0].coverStartDate?.toString().trim().length > 0) ? cover.riskItems[0].coverStartDate : "";

    let coverType = "Comprehensive cover on agreed value";
    switch (cover.productId.toUpperCase()) {
        case COMPREHENSIVE_MOTORBIKE_COVER_TYPE: { coverType = "Comprehensive cover on agreed value"; break; }
        case THIRDPARTY_MOTORBIKE_COVER_TYPE: { coverType = "Third party"; break; }
        case THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE: { coverType = "Third party and theft"; break; }
        case THEFT_MOTORBIKE_COVER_TYPE: { coverType = "Theft"; break; }
    }

    return (
        <>
            {isMobile &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Motorbike" />
            }

            <>
                <div className={showPhotos ? 'card' : 'box mb-3'} id="Policy-details-motorbike">
                    {!reminderDismissed && cover && cover.riskItems && cover.riskItems[0].inspectionRequired &&
                        <div className="Reminder-banner banner-padding">
                            <div className="cursor-pointer row noma" onClick={handleSelfInspectionRequired}>
                                <div className="nopa mr-15px">
                                    <img src="Images/White.svg" className="warning-icon-car" />
                                </div>
                                <div className="col-10 nopa">
                                    <p className="Monthly-mileage-update-car mb-0px">Self-inspection required. <Link onClick={handleSelfInspectionRequired} id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder-car">Tap here.</Link> </p>
                                </div>
                            </div>
                            <div onClick={dismissMonthlyMileageReminder}>
                                <Image className="Reminder-banner-close-img-car" src="./images/icons-navigation-close-16-px-white.svg" alt="Dismiss" />
                            </div>
                        </div>
                    }
                    <div className="d-lg-block d-none" id="PolicyDetails">
                        <div className="pl-3 pr-3 pt-3">
                            <div id="firstDiv" className={!hasError ? 'border-bottom' : 'border-0'}>

                                {showPhotos && !hasError &&
                                    <>
                                        <div className="row noma">
                                            <div className="col-lg-8 col-md-8 col-12 nopa">
                                                <p className="font-size-22px font-weight-bold line-height-normal mb-10px mb-15px">Motorbike self-inspection details</p>
                                                <div className="mb-10px">
                                                    <p className="font-weight-normal line-height-normal mb-3px">{cover.riskItems[0].description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                                {!showPhotos &&
                                    <>
                                        <div className="row mb-lg-0">
                                            <div className="col-7">
                                                <h2 className="carName mb-0">{!showPhotos ? cover.riskItems[0].description : 'Motorbike self-inspection details'}</h2>
                                                {showPhotos &&
                                                    <p className="font-weight-normal line-height-normal mb-3px">{cover.riskItems[0].description}</p>
                                                }
                                            </div>
                                            <div className="col-5 text-right">
                                                {!isInEdit && !showPhotos &&
                                                    <button className="btn btn-outline-red mb-3 mt-3" onClick={editPolicyInfo} id="EditPolicy">Update policy</button>
                                                }
                                                {isInEdit &&
                                                    <div className="">
                                                        <div className="mt-3 mb-3">
                                                            <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                                            <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </>
                                }

                                {!showPhotos &&
                                    <>
                                        <div className="row">
                                            <div className="col-lg-7">
                                            <p className="mb-0">{coverType}</p>
                                                <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                                {coverStartDate.length > 0 &&
                                                    <div className="mb-3">
                                                        <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                                        <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                                    </div>
                                                }
                                            </div>
                                            <div className="col-lg-5 text-right">
                                                <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <p className="mb-0"><b>Excess amount</b></p>
                                                <p className="excessAmount">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : cover.riskItems[0].excessDescription}</p>
                                            </div>
                                            {cover.riskItems[0].inspectionRequired &&
                                                <div className="col-lg-6 text-right">
                                                    <button className="btn self-inspection-button" onClick={handleSelfInspectionRequired}>Self-inspection required</button>
                                                </div>
                                            }
                                        </div>
                                    </>
                                }

                            </div>
                            {showPhotos &&
                                <div className="mt-20px">
                                    <SelfinspectDetails />
                                </div>
                            }
                            {!showPhotos &&
                                <>
                                    <div id="BenefitsDiv" className="mt-2">
                                        <p className="Benefits">Benefits</p>
                                        <div className="row">
                                        <div className="col-lg-3 pr-0 new-benefits-col">
                                                <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">Roadside assistance</span>
                                            </div>
                                            <div className="col-lg-3 p-0 new-benefits-col">
                                                <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">Accident assistance</span>
                                            </div>
                                            <div className="col-lg-3 p-0 new-benefits-col">
                                                <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">Medical assistance</span>
                                            </div>
                                            <div className="col-lg-3 p-0 new-benefits-col">
                                                <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">Liability to other parties</span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {!cover.riskItems[0].inspectionRequired && selfInspectionEnabled && !showPhotos &&
                                <>
                                    <hr className="policy-details-hr mt-13px mb-15px" />
                                    <div className="inspectionBlock row noma text-lg-left text-center">
                                        <div className="nopa inspectionPolicyProduct">
                                            <img src="./Images/OnlineQuotes/icon-addcover-motorbike.svg" title="Car insurance" alt="car insurance" className="add-cover-image" />
                                        </div>
                                        <div className="col-lg col-12 nopa">
                                            <div className="row noma">
                                                <div className="col-lg-8 col-12 px-0 nopa">
                                                    <p className="mb-0 font-size-16px font-weight-bold mt-lg-10px">Self-inspection complete</p>
                                                </div>
                                                <div className="col-lg col-12 nopa text-lg-right mt-sm-15px mt-lg-0px">
                                                    <button className="btn btn-solid-red inspection-view-btn" onClick={handleShowSelfInspectPhotos}>View details</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {!showPhotos &&
                                <>
                                    <div>
                                        <hr className="policy-details-hr mt-14px mb-15px" />
                                        {vapsList &&
                                            <>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional cover</p>
                                                <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the optional extra cover you’ve added to your policy… To add more cover, tap on the button below</p>
                                                <div id="OptionalExtras" className="mt-lg-4">
                                                    {vapsList}
                                                </div>
                                                <div className="hideOverflow">
                                                    <div className="float-right">
                                                        <button className="btn btn-solid-green" onClick={editPolicyInfo} id="addMoreVap">Add optional cover</button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {!vapsList &&
                                            <>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional cover</p>
                                                <p className="font-weight-500 line-height-normal mb-10px">These products come with a small additional premium but offer major peace of mind. To add cover, tap on the button below</p>
                                                <div className="hideOverflow">
                                                    <div className="float-right">
                                                        <button className="btn btn-solid-green" onClick={editPolicyInfo} id="addMoreVap">Add optional cover</button>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        <hr className="policy-details-hr mt-14px mb-15px" />
                                    </div>
                                    <div>
                                        {accessoryList &&
                                            <>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Accessories</p>
                                                <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the accessories you’ve added to your policy… To add more accessories, tap on the button below</p>
                                                <div id="Accessories">
                                                    {accessoryList}
                                                </div>
                                                <div className="hideOverflow">
                                                    <div className="float-right">
                                                        <button className="btn btn-solid-green" onClick={editPolicyInfo} id="addMoreAccessorie">Add accessories</button>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        {!accessoryList &&
                                            <>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Accessories</p>
                                                <p className="font-weight-500 line-height-normal mb-10px">The insured value of your motorbike covers the value of the motorbike, including the standard,
                                                    factory-fitted sound equipment and accessories. If your motorbike has additional extras which
                                                    aren’t standard and/or factory-fitted, you must specify and insure them separately in
                                                    order to have cover for them. To add accessories, tap on the button below</p>
                                                <div className="hideOverflow">
                                                    <div className="float-right">
                                                        <button className="btn btn-solid-green" onClick={editPolicyInfo} id="addMoreAccessorie">Add accessories</button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <hr className="policy-details-hr mt-14px mb-15px" />
                                    </div>
                                    <div id="DetailsDiv" className="mt-lg-4 pb-lg-4">
                                        <Accordion>
                                        <Card className="">
                                            <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                                <Accordion onSelect={(e) => setAccordionFAQActiveKey(Number(e))}>
                                                    {faq}
                                                </Accordion>
                                            </div>
                                        </Card>
                                        </Accordion>
                                    </div>
                                </>
                            }
                        </div>
                    </div>

                    <div className="d-lg-none d-block" id="PolicyDetailsMobile" style={{ display: "none" }}>
                        <div className="pl-3 pr-3">
                            <div id="firstDivMobile" className="border-bottom">
                                <h2 className="carName mb-0 pt-3">{cover.riskItems[0].description}</h2>
                                <div className="row">
                                    <div className="col-12">
                                        <p className="mb-0">Comprehensive cover (on retail value)</p>
                                        <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                        {coverStartDate.length > 0 &&
                                            <div className="mb-3">
                                                <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <p className="mb-0"><b>Excess amount</b></p>
                                        <p className="excessAmount">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : cover.riskItems[0].excessDescription}</p>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <button className="btn btn-outline-red" onClick={editPolicyInfo}>Update policy</button>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim</button>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    {cover.riskItems[0].inspectionRequired &&
                                        <div className="col-12">
                                            <button className="btn btn-solid-red" onClick={handleSelfInspectionRequired}>Self-inspection required</button>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div id="BenefitsDiv" className="mt-2">
                                <p className="Benefits">Benefits</p>
                                <div className="row">
                                    <ul className="benefitsCheck">
                                        <li>Roadside assistance</li>
                                        <li>Accident assistance</li>
                                        <li>Medical assistance</li>
                                        <li>Liability to other parties</li>
                                    </ul>
                                </div>
                            </div>
                            {!cover.riskItems[0].inspectionRequired && selfInspectionEnabled && !showPhotos &&
                                <>
                                    <hr className="policy-details-hr mt-13px mb-15px" />
                                    <div className="inspectionBlock row noma text-lg-left text-center mb-20px">
                                        <div className="nopa inspectionPolicyProduct">
                                            <img src="./Images/OnlineQuotes/icon-addcover-motorbike.svg" title="Car insurance" alt="car insurance" className="add-cover-image" />
                                        </div>
                                        <div className="col-lg col-12 nopa">
                                            <div className="row noma">
                                                <div className="col-lg-8 col-12 px-0 nopa">
                                                    <p className="mb-0 font-size-16px font-weight-bold mt-lg-10px">Self-inspection complete</p>
                                                </div>
                                                <div className="col-lg col-12 nopa text-lg-right mt-sm-15px mt-lg-0px">
                                                    <button className="btn btn-solid-red inspection-view-btn" onClick={handleShowSelfInspectPhotos}>View details</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {!showPhotos &&
                                <>
                                    <div>
                                        {vapsList &&
                                            <>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional cover</p>
                                                <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the optional extra cover you’ve added to your policy… To add more cover, tap on the button below</p>
                                                <div id="OptionalExtras" className="mt-lg-4">
                                                    {vapsList}
                                                </div>
                                                <div className="hideOverflow">
                                                    <div className="float-right">
                                                        <button className="btn btn-solid-green" onClick={editPolicyInfo} id="addMoreVap">Add optional cover</button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {!vapsList &&
                                            <>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional cover</p>
                                                <p className="font-weight-500 line-height-normal mb-10px">These products come with a small additional premium but offer major peace of mind. To add cover, tap on the button below</p>
                                                <div className="hideOverflow">
                                                    <div className="float-right">
                                                        <button className="btn btn-solid-green" onClick={editPolicyInfo} id="addMoreVap">Add optional cover</button>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        <hr className="policy-details-hr mt-14px mb-15px" />
                                    </div>
                                    <div>
                                        {accessoryList &&
                                            <>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Accessories</p>
                                                <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the accessories you’ve added to your policy… To add more accessories, tap on the button below</p>
                                                <div id="Accessories">
                                                    {accessoryList}
                                                </div>
                                                <div className="hideOverflow">
                                                    <div className="float-right">
                                                        <button className="btn btn-solid-green" onClick={editPolicyInfo} id="addMoreAccessorie">Add accessories</button>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        {!accessoryList &&
                                            <>
                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Accessories</p>
                                                <p className="font-weight-500 line-height-normal mb-10px">The insured value of your motorbike covers the value of the motorbike, including the standard,
                                                    factory-fitted sound equipment and accessories. If your motorbike has additional extras which
                                                    aren’t standard and/or factory-fitted, you must specify and insure them separately in
                                                    order to have cover for them. To add accessories, tap on the button below</p>
                                                <div className="hideOverflow">
                                                    <div className="float-right">
                                                        <button className="btn btn-solid-green" onClick={editPolicyInfo} id="addMoreAccessorie">Add accessories</button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <hr className="policy-details-hr mt-14px mb-15px" />
                                    </div>
                                    <div id="DetailsDiv" className="mt-4 pb-3">
                                        <Accordion>
                                        <Card className="">
                                            <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                                <Accordion onSelect={(e) => setAccordionFAQActiveKey(Number(e))}>
                                                    {faq}
                                                </Accordion>
                                            </div>
                                        </Card>
                                        </Accordion>
                                    </div>
                                </>
                            }
                            {(showPhotos || hasError) &&
                                <div className="mt-10px mb-10px">
                                    <SelfinspectDetails />
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {!showPhotos &&
                    <>
                        <Card className="mt-3 mb-5">
                            <Card.Body>
                                <div className="row">
                                    <div className="col-lg-2 col-3">
                                        <div className="motorbike"></div>
                                    </div>
                                    <div className="col-lg-10 col-9">
                                        <div className="row">
                                            <div className="col-10 px-0 mt-3">
                                                <p className="mb-0"><b>Add motorbike insurance</b></p>
                                            </div>
                                            <div className="col-2 mt-2 pl-0 pl-lg-2" style={{ paddingTop: "2px" }}>
                                                <Image src="./Images/TopNav/add-cover-nugreen-46px-46px.svg" className="mx-auto d-block cursor-pointer" onClick={handleCallMeBack} style={{ height: "30px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </>
                }
            </>
            {showPhotos && !hasError &&
                <>
                    <div className="col-lg col-12 nopa text-sm-center text-lg-right mt-15px mb-15px">
                        <button id="ViewSelfInspectBack" className="btn btn-solid-red w-sm-100" onClick={handleShowSelfInspectPhotos}>Back to personal policy</button>
                    </div>
                </>
            }
        </>
    )
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        ssp: state.ssp
    }
}

export default connect(mapStateToProps)(PolicyDetailsMotorbike);